import {View, Sync} from 'MWC';
import greenCardOrdeModel from '../models/greenCardOrder.m.js';
import tpl from '../templates/interactive.jsx';
import {apiback} from 'config';
import {formatter, IPhone} from 'MWComponents';

const data = {
    contactPhoneNumber: '+380'
};

export default class extends View {
    template = tpl;

    constructor() {
        super();
        this.state = {
            activeScreen: 'form',
            model: new greenCardOrdeModel(data),
            productName: '',
            ageConfirm: false
        };

        this._initMethods();
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    }

    onBlurHandle(name) {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    }

    handleCheckbox() {
        this.setState(prevState => ({ageConfirm: !prevState.ageConfirm}));
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
    }

    handleEscape(event) {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    }

    closeModal(event) {
        event ? event.stopPropagation() : this.props.closeModal();

        const target = event && event.target,
            classesToClose = ['form-wrapper', 'close-button', 'btn-transparent'];

        if (target && classesToClose.some(className => target.classList.contains(className))) {
            this.props.closeModal();
        }
    }

    _phoneFormat = value => {
        if (value instanceof IPhone) {
            return value.toString('contact');
        } else {
            return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
        }
    };

    async sendForm() {
        const {contactPhoneNumber} = this.getModel().fields,
            Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            data = {
                conv_data: {
                    phone: contactPhoneNumber.value,
                    utm_source: 'site',
                    product: this.state.productName
                },
                hash:
                    this.state.productName === 'kid-card' ? 'D6F08E241D9F6EFC' : '4RR2342L90V22AE7'
            },
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: data,
                cache: false
            });

        if (this.state.productName === 'kid-card') {
            data.conv_data.age = this.state.ageConfirm ? 'child' : 'per';
        }

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                window.dataLayer.push({event: 'sendgreenform'});
                this.setState({
                    activeScreen: 'success'
                });
            }
        } catch (error) {
            this.setState({
                activeScreen: 'error'
            });
            return error;
        }
    }

    _initMethods() {
        this.handleChange = this.handleChange.bind(this);
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.sendForm = this.sendForm.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
    }

    static displayName = 'Green.Card.Order';
}
